import { defaultOptions as n } from "./index23.mjs";
import { initReactI18next as s } from "./index45.mjs";
const e = (t, i) => (t.use(s).init({
  ...n,
  ...i
}), {
  i18n: t
});
export {
  e as initI18nInstance
};
